<template #content>

    <div class="w-full">
        <h5 class="text-gray-500" >Data do agendamento <span class="text-red-500">**</span></h5>
        <div class="field flex">
            <div class="w-12">
                <FloatLabel >
                    <DatePicker :showButtonBar= "true" v-model="form.data_instalacao" inline showWeek class="w-full sm:w-[30rem]" />
                </FloatLabel>
            </div>
        </div>
        <div class="w-12">
            <div>
                <FloatLabel class="mt-4">
                    <InputText v-model="form.hora_instalacao" id="hora_instalacao"  class="w-full" />
                    <label for="hora_instalacao">Horário Instalação</label>
                </FloatLabel>

                <FloatLabel class="mt-4">
                    <InputText v-model="form.instalador" id="instalador"  class="w-full" />
                    <label for="instalador">Instalador</label>
                </FloatLabel>
            </div>
        </div>
    </div>
</template>

<script>
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import Select from 'primevue/select';
import InputMask from 'primevue/inputmask';
import Checkbox from 'primevue/checkbox';
import AutoComplete from 'primevue/autocomplete';
import DatePicker from 'primevue/datepicker';
import InputNumber from 'primevue/inputnumber';
import Textarea from 'primevue/textarea';
import Button from 'primevue/button';
import InputGroup from 'primevue/inputgroup';
import InputGroupAddon from 'primevue/inputgroupaddon';
import Panel from 'primevue/panel';

export default {
    components: { FloatLabel,
                  InputGroup,
                  InputGroupAddon,
                  Button,
                  InputText,
                  InputMask,
                  Select,
                  Textarea,
                  AutoComplete,
                  Checkbox,
                  DatePicker,
                  InputNumber,
                  Panel,
                },
    props: {
        form: {},
        errors: {},
        permissoes: {},
    },
    emits: ['save','close'],
    data() {
        return {
            isLoading: false,
        }
    },

}
</script>
